export default __webpack_public_path__ + "static/media/java.12a207f4.pdf";